import { gatewaySectorWorkFlows } from "../../../../../../../../../gateways/gatewaySectorWorkFlows"; 
import { PaginatedOtherAreasResponse } from "../../../../../../../../shared/components/features/scope-of-work/components/areas/interfaces/otherAreas.interface";

export const getOtherAreas = async ({
  page,
  pageSize,
  categoryUid,
  typeOfService
}: {
  page: number;
  pageSize: number;
  categoryUid: string;
  typeOfService: string;
}): Promise<PaginatedOtherAreasResponse> => {

  const res = await gatewaySectorWorkFlows.get(
    `/areas?category=${categoryUid}&typeOfService=${typeOfService}&page=${page}&pageSize=${pageSize}`
  );

  return res.data?.data || res.data;
};
